var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUruguay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.86956H23.5866C23.2857 7.75328 22.8284 6.70136 22.2387 5.73911H12V8.86956Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53015 21.3913H19.4698C20.565 20.5191 21.5042 19.4596 22.2387 18.2609H1.76129C2.49587 19.4596 3.43506 20.5191 4.53015 21.3913Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0V2.60869H19.4699C17.42 0.976125 14.8242 0 12 0Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.86956H23.5866C23.2857 7.75328 22.8284 6.70136 22.2387 5.73911H12V8.86956Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 13.0831 0.144375 14.1323 0.413391 15.1305H23.5867C23.8556 14.1323 24 13.0831 24 12H0Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 7.02287L8.96921 7.71226L9.74963 9.13163L8.15822 8.82723L7.95657 10.4348L6.84816 9.25243L5.73966 10.4348L5.53805 8.82723L3.94665 9.13154L4.72702 7.71221L3.26152 7.02287L4.72707 6.33357L3.94665 4.91419L5.538 5.2186L5.73971 3.61102L6.84816 4.7934L7.95661 3.61102L8.15822 5.2186L9.74968 4.91419L8.96925 6.33362L10.4348 7.02287Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUruguay);
export default __webpack_public_path__ + "static/media/uruguay.44cf02475ebc16c731c7dfca2b0aa5c2.svg";
export { ForwardRef as ReactComponent };